import './App.css';
import Hello from './screens/splashes/hello';
import Game from './screens/game/game';
import { useEffect, useState } from 'react';
import Score from './screens/score/score';
import { questions } from './questions-array/questions';
import ScoreProvider from './store/score-provider';
import Login from './login/login';
import TimerProvider from './store/timerState/timer-provider';
function App() {

  const [gameFinished, setGameFinished] = useState(false);
  const [startGame, setStartGame] = useState(false);
  const [logged, setLogged] = useState(false);
  const [isPortrait, setIsPortrait] = useState(true);
  let questionsNumber = questions.length
  function gameFinishedHandler(finished) {
    if (finished) {
      setGameFinished(true)
    }
  }
  let allContent =
    isPortrait ?
      (
        <div className='background-image' >
          <div className='mainLogo' />
          <div className="deck" />
          <div className='board'>
            {!logged ? <Login onLogIn={() => {
              setLogged(true)
            }} /> :
              (
                <div className='board'>
                  {!startGame && <Hello startGameHandler={() => { setStartGame(true) }} />}
                  {startGame && !gameFinished && <Game onFinish={gameFinishedHandler} />}
                  {startGame && gameFinished && <Score questions={questionsNumber} />}
                </div>
              )
            }

          </div>
        </div>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
          <h1 style={{ color: 'white', fontSize: '50px' }}>Please use portrait mode</h1>
        </div>

      )

  useEffect(() => {
    if (window.innerWidth > window.innerHeight && (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(navigator.userAgent))) {
      setIsPortrait(false)
    }
    else {
      setIsPortrait(true)
    }
  }, [window.innerWidth])
  return (
    <ScoreProvider>
      <TimerProvider>
        <div
          className='background-image'  >
          {allContent}
          <div className="landscape" >
            <h1 style={{ color: 'white', fontSize: '50px', alignSelf: 'center' }}>Please use portrait mode</h1>
          </div>
        </div>
      </TimerProvider>
    </ScoreProvider>
  );
}
export default App;